<template>
  <div class="testimonial-area ptb-100 position-relative z-1">
    <div class="container">
      <div class="section-title mw-860 m-auto text-center">
        <span class="top-title">آراء عملائنا</span>
        <h2>لماذا يختارنا مشتركو الـ IPTV؟</h2>
        <p>
          لقد قمنا بجمع آراء عملائنا الذين استمتعوا بأفضل تجربة بث للقنوات العربية والأجنبية بجودة فائقة.
        </p>
      </div>
    </div>

    <div class="container mw-1356">
      <div class="masonrow">
        <div
          class="item"
          v-for="(testimonial, index) in paginatedTestimonials"
          :key="index"
        >
          <div class="testimonial-single-item">
            <ul class="ps-0 list-unstyled d-flex gap-1">
              <li v-for="star in 5" :key="star">
                <i class="ri-star-fill"></i>
              </li>
            </ul>
            <h3>{{ testimonial.name }}</h3>
            <p>{{ testimonial.review }}</p>
          </div>
        </div>
      </div>

      <!-- Pagination -->
      <div class="pagination-area text-center mt-4">
        <span
          class="next page-numbers"
          :class="{ disabled: currentPage === 1 }"
          @click="prevPage"
        >
          <i class="ri-arrow-left-s-line"></i>
        </span>

        <span
          v-for="page in totalPages"
          :key="page"
          class="page-numbers"
          :class="{ current: currentPage === page }"
          @click="goToPage(page)"
        >
          {{ page }}
        </span>

        <span
          class="next page-numbers"
          :class="{ disabled: currentPage === totalPages }"
          @click="nextPage"
        >
          <i class="ri-arrow-right-s-line"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";

interface Testimonial {
  name: string;
  review: string;
  rating: number;
}

export default defineComponent({
  // تم تغيير الاسم هنا لتجنب خطأ ESLint
  name: "ClientTestimonials",
  setup() {
    const testimonials = ref<Testimonial[]>([
      {
        name: "أحمد ك.",
        rating: 5,
        review: "تجربة رائعة! القنوات العربية تعمل بثبات عالٍ وبدون أي تقطيع، خاصة أثناء مباريات كرة القدم. شكراً لكم.",
      },
      {
        name: "سارة م.",
        rating: 5,
        review: "خدمة العملاء ممتازة جداً، ساعدوني في ضبط الإعدادات على شاشة سمارت في دقائق. الاشتراك يستحق كل قرش.",
      },
      {
        name: "ياسر ع.",
        rating: 5,
        review: "أفضل اشتراك IPTV جربته. جودة 4K حقيقية والقنوات مرتبة بشكل ممتاز. أنصح به الجميع.",
      },
      {
        name: "محمد س.",
        rating: 5,
        review: "كنت أعاني من التقطيع مع سيرفرات أخرى، لكن مع سيرفركم، البث مستقر تماماً حتى في أوقات الذروة.",
      },
      {
        name: "نورة ه.",
        rating: 5,
        review: "مكتبة الأفلام والمسلسلات العربية والأجنبية ضخمة ومتجددة دائماً. ترفيه لا ينتهي!",
      },
      {
        name: "خالد و.",
        rating: 5,
        review: "خدمة احترافية بكل ما تحمله الكلمة من معنى. الثبات والسرعة في تفعيل الاشتراك كانا فوق التوقعات.",
      },
      {
        name: "عمر ف.",
        rating: 5,
        review: "بصفتي مهووساً بالمباريات، هذا السيرفر هو الحل الأمثل لي. لا تفوتني أي مباراة بفضل ثبات البث.",
      },
      {
        name: "ليلى م.",
        rating: 5,
        review: "سهولة الاستخدام وتنوع القنوات العربية جعلت من اشتراكي هذا الخيار المفضل لعائلتي بالكامل.",
      },
      {
        name: "سامر ر.",
        rating: 5,
        review: "دعم فني 24/7 واحترافية عالية. تجربة IPTV هذه غيرت نظرتي عن خدمات البث بالكامل.",
      }
    ]);

    const currentPage = ref(1);
    const itemsPerPage = ref(9);

    const totalPages = computed(() =>
      Math.ceil(testimonials.value.length / itemsPerPage.value)
    );

    const paginatedTestimonials = computed(() => {
      const start = (currentPage.value - 1) * itemsPerPage.value;
      return testimonials.value.slice(start, start + itemsPerPage.value);
    });

    const goToPage = (page: number) => {
      if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
      }
    };

    const nextPage = () => {
      if (currentPage.value < totalPages.value) {
        currentPage.value++;
      }
    };

    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--;
      }
    };

    return {
      testimonials,
      currentPage,
      paginatedTestimonials,
      totalPages,
      goToPage,
      nextPage,
      prevPage,
    };
  },
});
</script>